"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoCompleteStatusResponseToJSON = exports.AutoCompleteStatusResponseFromJSONTyped = exports.AutoCompleteStatusResponseFromJSON = void 0;
var runtime_1 = require("../runtime");
function AutoCompleteStatusResponseFromJSON(json) {
    return AutoCompleteStatusResponseFromJSONTyped(json, false);
}
exports.AutoCompleteStatusResponseFromJSON = AutoCompleteStatusResponseFromJSON;
function AutoCompleteStatusResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'autoCompleteOperational': !(0, runtime_1.exists)(json, 'autoCompleteOperational') ? undefined : json['autoCompleteOperational'],
        'otherPlacesApiOperational': !(0, runtime_1.exists)(json, 'otherPlacesApiOperational') ? undefined : json['otherPlacesApiOperational'],
    };
}
exports.AutoCompleteStatusResponseFromJSONTyped = AutoCompleteStatusResponseFromJSONTyped;
function AutoCompleteStatusResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'autoCompleteOperational': value.autoCompleteOperational,
        'otherPlacesApiOperational': value.otherPlacesApiOperational,
    };
}
exports.AutoCompleteStatusResponseToJSON = AutoCompleteStatusResponseToJSON;
